import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { VbUiTextInputDirective } from 'rev-shared/ui/textInput/VbUiTextInput.Directive';

import { VbUiSearchInputComponent } from './VbUiSearchInput.Component';


const components = [
	VbUiSearchInputComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		VbUiTextInputDirective
	]
})
export class SearchInputModule {}
